<template>
	<div class="summary-table-header-cell tw-flex tw-justify-center tw-items-center">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'summary-table-header-cell',
};
</script>

<style lang="scss" scoped>
.summary-table-header-cell {
	min-height: 80px;
	max-height: 80px;
	border-bottom: 1px solid #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/process/job-valuation/job-valuation-summary-table/summary-table-header-cell.vue